<p-dialog class="pettyCashDialog" [style]="{width: '720px', maxWidth: '95vw'}" [header]='setLabel("addPettyExpenseHeaderLabel")'
    [(visible)]="pettydialogVisibility" (onHide)="onBeforeDialogHide()">
    <div class="payout-main-wrapper">
        <div class="payout-fields">
            <label>{{setLabel("paymentModeLabel")}}</label>
            <p-dropdown [options]="paymentOptions" (onChange)="onPaymentModeChange($event.value)"></p-dropdown>
        </div>
        <div class="payout-fields">
                <label>{{setLabel("dateLabel")}}</label>
                <input type="date" name="expenseDate" [max]="currentDate" [(ngModel)]="expenseDate" />
        </div>

        <div style="display: flex; align-items: center; justify-content: space-between; margin: 8px 0 2px 0;">
            <label style="font-weight: 600;">Expenses</label>
            <button pButton type="button" class="p-button-success" style="padding: 4px 10px;"
                (click)="addExpenseLine()">Add Expenses</button>
        </div>
        <div style="font-size: 13px; color: #1f1f1f; margin-bottom: 10px;">
            Total: {{ getTotalAmount() | number: '1.0-0' }}
        </div>

        <div *ngFor="let line of expenseLines; let i = index" style="border: 1px solid #d6d6d6; border-radius: 6px; padding: 10px; margin-bottom: 12px; background: #fafafa;">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px;">
                <div style="font-weight: 600;">Expense {{ i + 1 }}</div>
                <button pButton type="button" class="p-button-danger" style="padding: 2px 8px;"
                    (click)="removeExpenseLine(i)">Remove</button>
            </div>

            <div class="payout-fields" style="margin-bottom: 8px;">
                <label>{{setLabel("expenseTypeLabel")}}</label>
                <p-dropdown [(ngModel)]="line.type" [options]="expenseTypeOptions"
                    (onChange)="onLineTypeChange(line)"></p-dropdown>
            </div>

            <div class="payout-fields" style="margin-bottom: 8px;">
                <label>{{setLabel("amountLabel")}}</label>
                <input type="number" min="0" pInputText [name]="'line-amount-' + i" [(ngModel)]="line.amount" />
            </div>

            <div *ngIf="line.type === 'Lending' || line.type === 'Account Deducted'" class="payout-fields" style="margin-bottom: 8px;">
                <Label *ngIf="line.type === 'Lending'">{{setLabel("borrowerNameLabel")}}</Label>
                <Label *ngIf="line.type === 'Account Deducted'">{{setLabel("accountHolderNameLabel")}}</Label>
                <p-dropdown [name]="'line-user-' + i" [options]="userOptions" [(ngModel)]="line.selectedUser"></p-dropdown>
            </div>

            <div *ngIf="line.type === 'Salary'" class="payout-fields" style="margin-bottom: 8px;">
                <Label>{{setLabel("userNameLabel")}}</Label>
                <p-dropdown [name]="'line-salary-user-' + i" [options]="userOptions" [(ngModel)]="line.selectedUser"></p-dropdown>
            </div>

            <div *ngIf="line.type === 'Purchasing'" class="payout-fields" style="margin-bottom: 8px;">
                <Label>{{setLabel("productNameLabel")}}</Label>
                <div style="max-height: 220px; overflow-y: auto; border: 1px solid darkgrey; border-radius: 4px; padding: 8px; background: white;">
                    <div *ngFor="let group of purchasedItemGroups" style="margin-bottom: 8px;">
                        <div style="font-weight: 600; margin-bottom: 4px;">{{ group.title }}</div>
                        <div *ngFor="let item of group.items" style="display: flex; align-items: center; margin-bottom: 4px;"
                            [style.background]="line.purchasedItems?.includes(item.value) ? '#f2f2f2' : 'transparent'"
                            [style.borderRadius]="'4px'"
                            [style.padding]="'2px 4px'">
                            <p-checkbox [inputId]="getLineInputId(line, item.inputId)" [value]="item.value" [name]="'purchasedItems-' + i" [(ngModel)]="line.purchasedItems"></p-checkbox>
                            <label [for]="getLineInputId(line, item.inputId)" style="margin-left: 8px;"
                                [style.color]="line.purchasedItems?.includes(item.value) ? '#1f1f1f' : '#4f4f4f'"
                                [style.fontWeight]="line.purchasedItems?.includes(item.value) ? '700' : '400'">{{ setLabel(item.labelKey) }}</label>
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="line.type === 'Bills'" class="payout-fields" style="margin-bottom: 8px;">
                <Label>{{setLabel("billTypeLabel")}}</Label>
                <select style="width: 100%; height: 2em; border: 1px solid darkgrey; background-image: none;" type="text" pInputText [name]="'line-bill-' + i" [(ngModel)]="line.billType">
                    <option [ngValue]="null" disabled>Select Bill Type</option>
                    <option value="Electricity">{{setLabel("electricityLabel")}}</option>
                    <option value="Internet">{{setLabel("internetLabel")}}</option>
                    <option value="Maintenance">{{setLabel("maintenanceLabel")}}</option>
                    <option value="Repairing">{{setLabel("repairingLabel")}}</option>
                    <option value="Water Bottles">{{setLabel("waterBottlesLabel")}}</option>
                    <option value="Other">{{setLabel("otherLabel")}}</option>
                </select>
            </div>

            <div class="payout-fields">
                <span>{{setLabel("commentLabel")}} (Line)</span>
            </div>
            <div class="payout-fields" style="margin-bottom: 0;">
                <textarea rows="3" [name]="'line-description-' + i" [(ngModel)]="line.description"></textarea>
            </div>
            <button pButton type="button" (click)="showAddProfileImage('Upload', i)">
    <i class="fa" [ngClass]="line.image ? 'fa-edit' : 'fa-upload'"></i>
    &nbsp;{{ line.image ? setLabel('changePhotoBtnLabel') : setLabel('uploadPhotoBtnLabel') }}
</button>
        </div>

        <div class="payout-fields">
            <span>{{setLabel("commentLabel")}} (Common)</span>
        </div>
        <div class="payout-fields" style="margin-bottom: 10px;">
            <textarea rows="3" [(ngModel)]="description" name="description"></textarea>
        </div>

      
        <div class="payout-fields">
            <button class="p-button-success" pButton [disabled]="submittingTransaction"
                (click)="addPettyExpense()">{{setLabel("addExpenseLabel")}}</button>
        </div>
    </div>
    <div  class="tecfolkProfileDialogFix">
        <p-dialog [header]='setLabel("addPettyImageHeaderLabel")' [(visible)]="isShowAddPettyImage">
            <app-add-pettyCash-image *ngIf="isShowAddPettyImage" [popupType]="addPettyImage" (closeThePopup)="hideAddProfileImage()"
                (outputImage)="handleImagefromNewProfile($event)"></app-add-pettyCash-image>
        </p-dialog>
        <!-- popupType : Upload | Cam -->
    </div>
</p-dialog>